import {
  NegotiationBoundaryBase,
  negotiationBoundariesSchema,
  negotiationBoundaryAdjustmentsSchema,
} from '@procureai/schemas';
import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { TsrctNegotiationStrategy } from '@/generated/gql/graphql';

import {
  negotiationOptionsLegacySchema,
  negotiationOptionsLegacyFormDataDefault,
} from './components/NegotiationOptionsLegacyForm/NegotiationOptionsLegacyForm.schema.ts';
import { mapSortTsrctNegotiationStrategyBoundaries } from './NegotiationTermsForm.util';

export const termsFormDataSchema = z.object({
  ...negotiationBoundariesSchema.shape,
  ...negotiationBoundaryAdjustmentsSchema.shape,
  ...negotiationOptionsLegacySchema.shape,
});

export type TermsFormData = z.infer<typeof termsFormDataSchema>;

export const termsFormDataDefault: DefaultValues<TermsFormData> = {
  boundaries: [{ base: NegotiationBoundaryBase.QUOTED_PRICE, upper: -0.08, lower: -0.03 }],
  boundaryAdjustments: {
    historicNegotiations: false,
    historicTenderData: false,
  },
  ...negotiationOptionsLegacyFormDataDefault,
};

interface StrategyRefinement extends Record<any, any> {
  strategy?: TsrctNegotiationStrategy;
}

export const TsrctTermsMapper = z
  .looseObject({})
  .transform(({ strategy, ...rest }: StrategyRefinement) => {
    const transformedStrategy = strategy
      ? {
          boundaries: mapSortTsrctNegotiationStrategyBoundaries(strategy.boundaryRules),
          boundaryAdjustments: {
            historicNegotiations: strategy.useHistoricNegotiationData,
            historicTenderData: strategy.useHistoricTenderData,
          },
        }
      : {};

    return {
      ...rest,
      ...transformedStrategy,
    };
  })
  .nullish();
